import * as React from 'react';
import { SpinningLoadingIcon } from '~/libs/ui/atoms/SpinningLoadingIcon';
import { humanDateWithTimeFromString } from '~/libs/utils/format/date';
import { ButtonAddData } from './ButtonAddData';
import { HelpLink } from './HelpLink';
import { ErpPackResponse } from 'com.cogvio.pricemonitor.api';

interface ScenarioHeaderProps {
	erpPack?: ErpPackResponse;
	erpSessionDate: string;
	loading: boolean;
	error: boolean;
	onDataAddRequest: () => void;
}

export function ScenarioHeader({ erpPack, erpSessionDate, loading, error, onDataAddRequest }: ScenarioHeaderProps) {
	return (
		<div className='px-10 bg-cBlue-50 border-b border-gray-200'>
			{loading && (
				<div className='w-full pt-5 flex justify-center items-center'>
					<div className='h-12'>
						<SpinningLoadingIcon />
					</div>
				</div>
			)}
			{!loading && !error && erpPack && (
				<>
					<div className='pt-2 w-full max-w-7xl mx-auto'>
						<ul className='flex justify-start cogvio-breadcrumb'>
							<li className='relative mr-6'>
								<a href='/irp/' className='text-label font-semibold'>
									IRP
								</a>
							</li>
							<li className='relative text-gray-500'>
								<span className='text-label'>{erpPack.brandName}</span>
								<span className='mx-1'>-</span>
								<span className='text-label'>{erpPack.virtualProductPackName.split('-')[1]}</span>
							</li>
						</ul>
					</div>
					<div className='pt-2 pb-3 w-full max-w-7xl mx-auto'>
						<span className='inline-block px-1.5 py-0.5 rounded-sm font-open text-label font-bold leading-4 text-gray-600 bg-white whitespace-nowrap tabular-nums'>
							{humanDateWithTimeFromString(erpSessionDate)}
						</span>
						<h1 className='block mt-1 font-display text-h3 font-semibold text-black tracking-wider'>
							{erpPack.brandName}

							<p className='inline-block pl-2 text-gray-700 font-normal tabular-nums'>
								{erpPack.virtualProductPackName.split('-')[1]}
							</p>
						</h1>
						<div className='pt-3 flex items-start'>
							<div className='pr-8 max-w-sm'>
								<h2 className='mb-0.5 font-display text-base font-medium text-cPurple-600 tracking-wider'>
									Price input, volume &amp; growth
								</h2>
								<p className='mb-2 font-display text-label leading-normal text-gray-500 tracking-wide'>
									View and correct the input prices. Add or update the volume & growth data to see revenues.
								</p>
								<ButtonAddData onClick={onDataAddRequest} />
							</div>
							<div className='px-8 border-l border-gray-300 max-w-md'>
								<h2 className='mb-0.5 font-display text-base font-medium text-cPurple-600 tracking-wider'>Help</h2>
								<p className='mb-2 font-display text-label leading-normal text-gray-500 tracking-wide'>
									View the list of countries and rules, that are implemented within this version of the external
									reference reference pricing model.
								</p>
								<HelpLink className='mr-2 btn-white-second' />
							</div>
						</div>
					</div>
				</>
			)}
		</div>
	);
}
